import { types } from "../types/types";

export const erroresReducer = (state = {}, action) => {
  switch (action.type) {
    case types.setError:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
